import { useEffect, useState } from "react";
import { TV_SERVICE_OPTION } from "./constants";

export const getFalconColorsClass = (type: string): string => {
  switch (type) {
    case "grey-600":
      return "falcon-grey-600";

    case "grey-500":
      return "falcon-grey-500";

    case "grey-100":
      return "falcon-grey-100";

    case "grey-400":
      return "falcon-grey-400";

    case "ice-white":
      return "falcon-ice-white";

    default:
      return "";
  }
};

export const getElementMaximumHeight = (
  idPrefix: string,
  totalCards: number
): void => {
  const heightArray: any[] = [];
  let maxValue: number;
  let item = 0;
  let val: HTMLElement | null;
  //push height of the elements into an array to find maximum value

  [...Array(totalCards)].forEach(() => {
    val = document.getElementById(`${idPrefix}${item}`);
    if (val != null) {
      val.style.height = "unset";
      heightArray.push(val?.clientHeight);
      item++;
    }
  });
  maxValue = Math.max(...heightArray);
  item = 0;
  //sets the maximum value obtained as minHeight to that element of each card
  [...Array(totalCards)].forEach(() => {
    val = document.getElementById(`${idPrefix}${item}`);
    if (val != null) {
      val.style.height = `${maxValue}px`;
    }
    item++;
  });
};

export const getFalconBackgroundColorClass = (type: string): string => {
  switch (type) {
    case 'grey-100':
      return 'falcon-background-grey-100';
    case 'ice-white':
      return 'falcon-background-ice-white';
    case 'transparent':
      return 'falcon-background-transparent';
    default:
      return '';
  }
};

export const getFalconGradientClass = (type: string): string => {
  switch (type) {
    case 'rubyglow-diagonal':
      return 'falcon-gradient-rubyglow-diagonal';

    case 'rubyglow-inverted-diagonal':
      return 'falcon-gradient-rubyglow-inverted-diagonal';

    case 'rubyglow-vertical':
      return 'falcon-gradient-rubyglow-vertical';

    case 'pinksky-diagonal':
      return 'falcon-gradient-pinksky-diagonal';
    
    case 'pinksky-inverted-diagonal':
      return 'falcon-gradient-pinksky-inverted-diagonal';

    case 'pinksky-vertical':
      return 'falcon-gradient-pinksky-vertical';

    case 'bluehaze-diagonal':
      return 'falcon-gradient-bluehaze-diagonal';

    case 'bluehaze-vertical':
      return 'falcon-gradient-bluehaze-vertical';

    case 'greencloud-diagonal':
      return 'falcon-gradient-greencloud-diagonal';

    case 'greencloud-inverted-diagonal':
      return 'falcon-gradient-greencloud-inverted-diagonal';

    case 'greencloud-vertical':
      return 'falcon-gradient-greencloud-vertical';

    case 'peachfog-diagonal':
      return 'falcon-gradient-peachfog-diagonal';
      
    case 'peachfog-inverted-diagonal':
      return 'falcon-gradient-peachfog-inverted-diagonal';

    case 'peachfog-vertical':
      return 'falcon-gradient-peachfog-vertical';

    case 'darkblue-haze':
      return 'falcon-gradient-dark-blue-haze';

    case 'skyfuel-diagonal':
      return 'falcon-gradient-skyfuel-diagonal';

    case 'skyfuel-vertical':
      return 'falcon-gradient-skyfuel-vertical';

    case 'skyfuel-inverted-diagonal':
      return 'falcon-gradient-skyfuel-inverted-diagonal';

    default:
      return '';
  }
};

export const countZero = (value: any) => {
  value = Number(value);
  let price: any = 0;
  const reg = '^[0-9][^.]*$';
  const isNumericPrice = new RegExp(reg).test(value.toString());
  if (isNumericPrice) {
    price = value + '.-';
  } else {
    price = value.toFixed(2).replace(/\.00$/, '');
  }
  return price;
};

export const setLocalStoreWithExpiry = (key: string, value: any, ttl?: any): void => {
  let item: any = null;
  const now: any = new Date();
  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  item = {
    value: value,
    expiry: ttl ? now.getTime() + ttl : null
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getLocalStorageWithExpiry = (key: string): any => {
  const itemStr = typeof window !== 'undefined' && localStorage.getItem(key);
  // if the item doesn't exist, return null
  const now: Date = new Date();
  if (!itemStr) {
    return null;
  }
  let item: any = {};
  try {
    item = JSON.parse(itemStr);
    if (item.expiry && now.getTime() > item.expiry) {
      removeLocalStorage(key);
      return null;
    }
  } catch (error) {
    return itemStr;
  }
  return item?.value;
};

export const removeLocalStorage = (key: string): void => {
  localStorage.removeItem(key);
};

export const viewport = (): string => {
  const [width, setWidth] = useState<number>(() =>
    typeof window !== 'undefined' ? window.innerWidth : 0
  );
  useEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    // Sync once on mount in case value drifted between SSR and hydration
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  if (width >= 1440) {
    return 'large-desktop';
  } else if (width < 1440 && width >= 1024) {
    return 'desktop';
  } else if (width < 1024 && width >= 768) {
    return 'tablet';
  } else if (width < 768 && width > 0) {
    return 'mobile';
  } else {
    return '';
  }
};

export const getCookies = (cname: string): any => {
  const name = cname + '=';
  const cookies = document.cookie.split(';');
  let cookieData: any;
  cookies.some((cookie) => {
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      cookieData = JSON.parse(decodeURIComponent(cookie.substring(name.length, cookie.length)));
      return true;
    }
    return false;
  });
  return cookieData;
};

export const isTouchScreen = (): boolean => {
  const [touchScreen, setTouchScreen] = useState<boolean>(false);
  const onResize = () => {
    const mediaQuery = window.matchMedia('(pointer:coarse)');
    setTouchScreen(mediaQuery.matches);
    };
  useEffect(() => {
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return touchScreen;
};

// get price value based on type
export const returnPriceByType = (priceList: any, type: string) => {
  const price = (priceList || [])?.filter((val: any) => val?.priceType?.toLowerCase() === type);
  if (price?.length > 0) {
    return price?.[0]?.value;
  } else {
    return '';
  }
};

//replace storyblok content{0} with dynamic value
export const replacePlaceholder = (source: string, params: any): string => {
  const text: string = source?.replace(
    /{\w+}/g,
    (placeholder: any) => params[placeholder.substring(1, placeholder.length - 1)] || placeholder
  );
  return text;
};

export const isModemPresent = () => {
  if (document) {
    if (document.getElementById('no-modem')) {
      return false;
    } else {
      return true;
    }
  }
  return false;
};

export const iconHandler = (type: string): string => {
  switch (type) {
    case 'success':
      return '/icons/checksuccess.svg';
    case 'error':
      return '/icons/error.svg';
    case 'info':
      return '/icons/info.svg';
    case 'warning':
      return '/icons/alert.svg';
    case 'tip':
      return '/icons/tip.svg';
    case 'infoWhite':
      return '/icons/info.svg';
    default:
      return '';
  }
};

// checks if the url is like "/lang/" and replaces it with '#'. Or returns the configured url
export const checkLinkWithLang = (url: string) => {
  if (typeof window !== 'undefined') {
    if (url == '/' + window.document.documentElement.getAttribute('lang') + '/') {
      return undefined;
    } else {
      return url;
    }
  } else {
    return '#';
  }
};

export const getSBAssetUrl = (wafIdentifier: any, image?: string): string => {
  const [defaultImageEndpoint]: [string] = ['https://a.storyblok.com/f/113473/'];
  const [s3Endpoint]: [string] = [wafIdentifier + 'asset/'];
  if (image && typeof image === 'string') {
    return image.replace(defaultImageEndpoint, `${s3Endpoint}`);
  }
  return image || '';
};

export const getCompressedImage = (wafIdentifier: any,imageUrl: string): string => {
  // eslint-disable-next-line @typescript-eslint/no-inferrable-types
    let extension: string = '';
  
    // to replace the default storyblok endpoint with sunrise.ch endpoint
    extension += getSBAssetUrl(wafIdentifier,imageUrl);
    // to add the compression parameters for image compression
    extension += '/m/';

    return extension;
};

//To get notes values
export const getNoteValues = (hardwareProducts: any, key: string) => {
  let value;
  if (hardwareProducts?.note) {
    (hardwareProducts?.note || []).forEach((data: any) => {
      data?.author === key && (value = data?.text);
    });
  }
  return value;
};

/**US 349849 - MIA migration
 *  price  model
 * @param value string | number
 * @returns
 * 2.0 -> 2.00
 * 2.1 -> 2.10
 * 2.15 -> 2.15
 * 0.0 -> 0.00
 * 0.5 -> 0.50
 */

export const countZeros = (value: any) => {
  value = Number(value);
  let price: any = 0;
  price = value.toFixed(2);
  return price;
};
export const viewportMultiItem = (): string => {
  const [width, setWidth] = useState<number>(() =>
    typeof window !== 'undefined' ? window.innerWidth : 0
  );
  useEffect(() => {
    const updateSize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', updateSize);
    // Sync once on mount in case value drifted between SSR and hydration
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  if (width >= 1440 && width < 7000) {
    return 'desktop';
  } else if (width >= 1024 && width < 1440) {
    return 'tabletLarge';
  } else if (width < 1024 && width >= 768) {
    return 'tabletMedium';
  } else if (width < 768 && width > 0) {
    return 'mobile';
  } else {
    return '';
  }
};

export const setSessionStorage = (sname: string, valueobj: any): any => {
  if (sname) sessionStorage.setItem(sname, JSON.stringify(valueobj));
};

export const getSessionStorage = (sname: string): any => {
  if (typeof window === 'undefined') {
    return null;
  }
  if (sname) {
    const sessionData = sessionStorage.getItem(sname);
    if (!sessionData) {
      return null;
    }
    return JSON.parse(sessionData);
  }
};

export const rp_lastcartItemWithParentPOType = (
    cart: any[],
    lastCartItems: Record<string, any>,
    parent: any,
    home: any
  ): Record<string, any> => {
    if (Array.isArray(cart)) {
      cart.forEach((cart_rp: any) => {
        // Detect which data structure we're working with
        const hasItemType = cart_rp?.itemType !== undefined;
        const hasProductOffering = cart_rp?.productOffering !== undefined;
        // Determine the type and children based on data structure
        let currentType: string | undefined;
        let children: any[] | undefined;
        
        if (hasItemType) {
          // First data structure: uses itemType and items
          currentType = cart_rp?.itemType;
          children = cart_rp?.items;

        } else if (hasProductOffering) {
          // Second data structure: uses productOffering.poType and cartItem
          currentType = cart_rp?.productOffering?.poType;
          children = cart_rp?.cartItem;

        }
        
        // Check if this is a parent order type
        const parentOrderTypes = [
          'MOBILE_ORDER',
          'HOME_ORDER',
          'STANDALONE_TV_ORDER',
          'MOBILE_INTERNET_ORDER',
          'EXTRASIM_RATEPLAN',
          'ACCESSORY',
          'STANDALONE_HARDWARE'
        ];
        
        // If this is a parent order, update home for this branch only
        let currentHome = home;
        if (currentType && parentOrderTypes.includes(currentType)) {
          currentHome = hasItemType ? cart_rp : cart_rp?.productOffering;
        }
        
        // If this is a leaf node (no children or empty children array)
        if (!children || children.length === 0) {
          if (cart_rp && currentHome) {
            // Get current item type based on data structure
            let itemType: string | undefined = currentType;
            
            // If itemType is undefined, try to infer from parent
            if (!itemType && hasProductOffering && parent?.productOffering?.poType) {
              // Use parent's poType as the item type for leaf nodes
              itemType = parent.productOffering.poType;
            }
            
            if (!itemType) {
              return;
            }
            
            // Get home type key based on data structure
            const homeTypeKey = hasItemType ? currentHome?.itemType : currentHome?.poType;
            
            if (!homeTypeKey) {
              return;
            }
            
            // Organize items by home type and item type
            if (Object.prototype?.hasOwnProperty.call(lastCartItems, homeTypeKey)) {
              if (Object.prototype?.hasOwnProperty.call(lastCartItems[homeTypeKey], itemType)) {
                // Item type already exists, push to array
                let temp = lastCartItems[homeTypeKey]?.[itemType] ?? [];
                if (!Array.isArray(temp)) {
                  temp = [temp];
                }
                temp.push(cart_rp);
                lastCartItems[homeTypeKey] = { ...lastCartItems[homeTypeKey], [itemType]: {...temp, itemType: itemType} };
              } else {
                // First item of this type
                const serviceOptionTypes = [
                  'TV_SERVICE_OPTION',
                  'INTERNET_SERVICE_OPTION',
                  'MOBILEPOSTPAID_SERVICE_OPTION',
                  'MOBILEPREPAID_SERVICE_OPTION'
                ];
                
                if (serviceOptionTypes.includes(itemType)) {
                  lastCartItems[homeTypeKey] = { ...lastCartItems[homeTypeKey], [itemType]: [{...cart_rp, itemType: itemType}]};
                } else {
                  lastCartItems[homeTypeKey] = { ...lastCartItems[homeTypeKey], [itemType]: {...cart_rp, itemType: itemType}};
                }
              }
            } else {
              // First time seeing this home type
              const serviceOptionTypes = [
                'TV_SERVICE_OPTION',
                'INTERNET_SERVICE_OPTION',
                'MOBILEPOSTPAID_SERVICE_OPTION',
                'MOBILEPREPAID_SERVICE_OPTION'
              ];
              if (serviceOptionTypes.includes(itemType)) {
                lastCartItems[homeTypeKey] = { 
                  [itemType]: [{...cart_rp, itemType: itemType}], 
                  ['PARENT_ITEM']: currentHome 
                };
              } else {
                lastCartItems[homeTypeKey] = { 
                  [itemType]: {...cart_rp, itemType: itemType}, 
                  ['PARENT_ITEM']: currentHome 
                };
              }
            }
          }
        } else {
          // Recursively process children with the current home context
          rp_lastcartItemWithParentPOType(children, lastCartItems, cart_rp, currentHome);
        }
      });
    }

  return lastCartItems;
};
export const isStandaloneOption = (product:any) =>{
  return product.some((item:any) => item.type === TV_SERVICE_OPTION);
}

/**
 * Returns a UTC timestamp in the format 'YYYYMMDDTHHmmss.SSS GMT'
 * Replaces moment().utc().format('YYYYMMDDTHHmmss.SSS') + ' GMT'
 */
export const getUtcTimestamp = (): string => {
  const now = new Date();
  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, '0');
  const day = String(now.getUTCDate()).padStart(2, '0');
  const hours = String(now.getUTCHours()).padStart(2, '0');
  const minutes = String(now.getUTCMinutes()).padStart(2, '0');
  const seconds = String(now.getUTCSeconds()).padStart(2, '0');
  const ms = String(now.getUTCMilliseconds()).padStart(3, '0');
  return `${year}${month}${day}T${hours}${minutes}${seconds}.${ms} GMT`;
};